import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// File upload thunk
export const uploadFileApi = createAsyncThunk(
  "UPLOAD_FILE",
  async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/file/public`,
        formData,
        config
      );
      
      let data_res = {
        status: "success",
        message: response,
        url: response.data.payload,
        fileName: file.name
      };
      return data_res;
    } catch (error) {
      let data_error = {
        status: "error",
        message: error.response?.data || "File upload failed, please try again.",
      };
      return data_error;
    }
  }
);

// Consultation observation thunk
export const consultationObservationApi = createAsyncThunk(
  "CONSULTATION_OBSERVATION",
  async (observationData) => {
    let raw = JSON.stringify(observationData);
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/appointment/consultation-observation`,
        raw,
        config
      );
      
      let data_res = {
        status: "success",
        message: response,
      };
      return data_res;
    } catch (error) {
      let data_error = {
        status: "error",
        message: error.response?.data || "Consultation observation failed, please try again.",
      };
      return data_error;
    }
  }
);

// Edit consultation observation thunk (PUT)
export const editConsultationObservationApi = createAsyncThunk(
  "EDIT_CONSULTATION_OBSERVATION",
  async (observationData) => {
    let raw = JSON.stringify(observationData);
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.put(
        `${API_BASE_URL}/appointment/consultation-observation`,
        raw,
        config
      );
      
      let data_res = {
        status: "success",
        message: response,
      };
      return data_res;
    } catch (error) {
      console.log("Redux thunk error:", error.response?.data); // Debug log
      
      let data_error = {
        status: "error",
        message: error.response?.data || "Edit consultation observation failed, please try again.",
        fullError: error.response?.data // Include the full error response
      };
      return data_error;
    }
  }
);

const ConsultationObservationSlice = createSlice({
  name: "CONSULTATION_OBSERVATION",
  initialState: {
    loading: false,
    error: null,
    uploadLoading: false,
    uploadError: null,
    uploadedFiles: {},
    editLoading: false,
    editError: null,
  },
  reducers: {
    clearUploadedFiles: (state) => {
      state.uploadedFiles = {};
    },
    clearErrors: (state) => {
      state.error = null;
      state.uploadError = null;
      state.editError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload file cases
      .addCase(uploadFileApi.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
      })
      .addCase(uploadFileApi.fulfilled, (state, action) => {
        state.uploadLoading = false;
        if (action.payload.status === "success") {
          // Store uploaded file URL with filename as key
          state.uploadedFiles[action.payload.fileName] = action.payload.url;
        }
      })
      .addCase(uploadFileApi.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.error.message;
      })
      // Consultation observation cases
      .addCase(consultationObservationApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(consultationObservationApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(consultationObservationApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Edit consultation observation cases
      .addCase(editConsultationObservationApi.pending, (state) => {
        state.editLoading = true;
        state.editError = null;
      })
      .addCase(editConsultationObservationApi.fulfilled, (state, action) => {
        state.editLoading = false;
      })
      .addCase(editConsultationObservationApi.rejected, (state, action) => {
        state.editLoading = false;
        state.editError = action.error.message;
      });
  },
});

export const { clearUploadedFiles, clearErrors } = ConsultationObservationSlice.actions;
export default ConsultationObservationSlice.reducer;